import {
  AI_TOOL_SELECT_USAGE_NOTE,
  AI_TOOL_WHERE_USAGE_NOTE,
  searchFallbackUsedSchema,
} from '@erikdakoda/ai-tool/findManyAiToolInput';
import { tool, zodSchema } from 'ai';
import { z } from 'zod';
import type { AiTool } from '@erikdakoda/ai-tool/types';
import { botsToolGroupIcon } from './toolGroupIcon';
import { findBotsInputSchema } from './findBotsInputSchema';

export { findBotsInputSchema };

export const findBotsOutputSchema = z.object({
  results: z
    .array(z.unknown())
    .describe(
      'Rows from findMany. Default minimal mask: id, name, description, group, handle. Shape follows caller flat `select` when provided.',
    ),
  count: z.number().int().describe('Number of rows returned (after take).'),
  searchFallbackUsed: searchFallbackUsedSchema,
});

export type FindBotsInput = z.infer<typeof findBotsInputSchema>;
export type FindBotsOutput = z.infer<typeof findBotsOutputSchema>;

export const findBots: AiTool<undefined, FindBotsInput, FindBotsOutput> = {
  id: 'findBots',

  group: 'bots',

  ...botsToolGroupIcon,

  userSelect: false,

  access: 'READ',

  tool: tool({
    description: `List bots using the structured filter DSL. ${AI_TOOL_WHERE_USAGE_NOTE}

Returns the same minimal default mask as \`searchBots\` (id, name, description, group, handle). ${AI_TOOL_SELECT_USAGE_NOTE}

Use \`searchText\` for indexed text search on name (substring) and description (full-text / english stem). Does not search group or handle. \`searchFallbackUsed\` is true only when typo-tolerant fallback ran.`,
    inputSchema: zodSchema(findBotsInputSchema),
    outputSchema: zodSchema(findBotsOutputSchema),
  }),
};
